// // import { createContext, useContext, useState, useEffect } from 'react'
// // import {jwtDecode} from 'jwt-decode'

// // const AuthContext = createContext()

// // export const AuthProvider = ({ children }) => {
// //   const [user, setUser] = useState(null)
// //   const [loading, setLoading] = useState(true)

// //   useEffect(() => {
// //     const token = localStorage.getItem('token')
// //     if (token) {
// //       try {
// //         const decoded = jwtDecode(token)
// //         setUser(decoded)  // Must include: id, email, role
// //       } catch (err) {
// //         localStorage.removeItem('token')
// //       }
// //     }
// //     setLoading(false)
// //   }, [])

// //   const login = (token) => {
// //     localStorage.setItem('token', token)
// //     const decoded = jwtDecode(token)
// //     setUser(decoded)
// //   }

// //   const logout = () => {
// //     localStorage.removeItem('token')
// //     setUser(null)
// //   }

// //   return (
// //     <AuthContext.Provider value={{ user, login, logout, loading }}>
// //       {children}
// //     </AuthContext.Provider>
// //   )
// // }

// // export const useAuth = () => useContext(AuthContext)

// import { createContext, useContext, useState, useEffect } from "react";
// import { jwtDecode } from "jwt-decode";

// const AuthContext = createContext();

// export const AuthProvider = ({ children }) => {
//   const [user, setUser] = useState(null);
//   const [role, setRole] = useState(null)
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     const token = localStorage.getItem("token");
//     if (token) {
//       try {
//         const decoded = jwtDecode(token);
//         setUser(decoded); // Must include: id, email, role
//       } catch (err) {
//         console.error("Invalid token:", err);
//         localStorage.removeItem("token");
//       }
//     }
//     setLoading(false);
//   }, []);

//   const login = (token) => {
//     localStorage.setItem("token", token);
//     const decoded = jwtDecode(token);
//     setUser(decoded);
//   };

//   const logout = () => {
//     localStorage.removeItem("token");
//     setUser(null);
//   };

//   const updateUser = (data) => {
//     setUser(data);
//     setRole(data.role);
//   };


//   return (
//     <AuthContext.Provider value={{ user, login, logout, loading }}>
//       {children}
//     </AuthContext.Provider>
//   );
// };

// // Custom hook
// export const useAuth = () => {
//   const context = useContext(AuthContext);
//   if (!context) {
//     throw new Error("useAuth must be used within an AuthProvider");
//   }
//   return context;
// };

import { createContext, useContext, useState, useEffect, useCallback, useMemo } from "react";
import { jwtDecode } from "jwt-decode";
import api from "../api/client";
import { telegramLogin } from "../api/auth";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [role, setRole] = useState(null);
  const [loading, setLoading] = useState(true);

  // On mount: read token + decode
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      try {
        const decoded = jwtDecode(token);
        setUser({
          ...decoded,
          avatarUrl: decoded.avatarUrl || null,
        });
        setRole(decoded.role?.toUpperCase()); // Normalize
        api.defaults.headers.Authorization = `Bearer ${token}`;
      } catch (err) {
        console.error("Invalid token:", err);
        localStorage.removeItem("token");
      }
    }
    setLoading(false);
  }, []);

  const login = useCallback((token, userData, navigate) => {
    localStorage.setItem("token", token);
    const decoded = jwtDecode(token);
    const updatedUser = { ...decoded, ...userData };
    setUser(updatedUser);
    setRole(userData.role?.toUpperCase());
    api.defaults.headers.Authorization = `Bearer ${token}`;

    if (navigate) {
      const target = userData.role?.toUpperCase() === "ADMIN"
        ? "/admin/dashboard"
        : "/";
      navigate(target, { replace: true });
    }
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("token");
    delete api.defaults.headers.Authorization;
    setUser(null);
    setRole(null);
  }, []);

  const updateUser = useCallback((data) => {
    setUser((prev) => ({ ...prev, ...data }));
    if (data.role) {
      setRole(data.role.toUpperCase());
    }
    // Optional: update token if new one is provided
    if (data.token) {
      localStorage.setItem("token", data.token);
      api.defaults.headers.Authorization = `Bearer ${data.token}`;
    }
  }, []);

  const loginWithTelegram = useCallback(async (initData) => {
    try {
      const { data } = await telegramLogin(initData);
      login(data.token, data.user);
      return true;
    } catch (error) {
      console.error("Telegram login failed:", error);
      return false;
    }
  }, [login]);

  const value = useMemo(() => ({
    user,
    role,
    loading,
    login,
    logout,
    updateUser,
    loginWithTelegram
  }), [user, role, loading, login, logout, updateUser, loginWithTelegram]);

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) throw new Error("useAuth must be used within AuthProvider");
  return context;
};